import { footerLinks } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-secondary-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">新黑料网</span>
            </div>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-foreground-600">
              每日更新全网最新爆料与今日快讯，聚焦最新事件进展，持续追踪新瓜动态。
            </p>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="mb-3 text-sm font-bold text-foreground-900">{col.title}</h4>
              <ul className="space-y-2">
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="mt-8 rounded-lg bg-background-50/60 px-4 py-3 text-xs leading-relaxed text-foreground-500">
          免责声明：本站为信息聚合展示，页面内容仅供浏览参考，均为静态示意，不构成任何事实认定或法律意见。请理性看待网络信息，以官方渠道披露为准。
        </p>

        <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-5 sm:flex-row">
          <span className="text-xs text-foreground-500">© 2026 新黑料网 · 保持理性，快乐吃瓜</span>
          <div className="flex items-center gap-4">
            <a href="#top" className="text-xs text-foreground-500 hover:text-primary-700">
              关于我们
            </a>
            <a href="#top" className="text-xs text-foreground-500 hover:text-primary-700">
              版权合作
            </a>
            <a href="#top" className="text-xs text-foreground-500 hover:text-primary-700">
              投稿线索
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}